import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Y from '../../../y18n'
import CountriesDropdown from '../../../common/dropdowns/countries-dropdown'
import * as simcardActions from '../../../store/simcards'
import * as productActions from '../../../store/products'
import Styles from '../../../common/styles'

const mapStateToProps = state => ({
  simcards: state.simcards,
  products: state.products
})

const mapDispatchToProps = dispatch => ({
  simcardActions: bindActionCreators(simcardActions, dispatch),
  productActions: bindActionCreators(productActions, dispatch)
})

const numberOfSimcardsSelect = [
  { id: '', value: 'Select number of simcards to add' },
  { id: '1', value: '1' },
  { id: '10', value: '10' },
  { id: '25', value: '25' },
  { id: '50', value: '50' },
  { id: '100', value: '100' }
]

class NewSimcardDialog extends Component {
  closeFormDialog = () => {
    this.props.simcardActions.resetActive()
  }

  inputChanged = name => e => {
    this.props.simcardActions.updateActive(name, e.target.value)
    if (name === 'country') {
      this.props.productActions.getProductsForCountry(e.target.value)
    } else if (name === 'imsi') {
      const hasError = !/^[0-9]{15}$/.test(e.target.value)
      this.props.simcardActions.updateActive(`imsiValidationError`, hasError)
    }
  }

  submitChanges = (e, simcard) => {
    e.preventDefault()
    this.props.simcardActions.createSimcard(simcard)
  }

  render () {
    const { classes, simcards, simcardActions, products } = this.props
    if (!simcards.active || !simcards.new) return null
    let { imsiValidationError } = simcards.active
    imsiValidationError = imsiValidationError === undefined ? true : imsiValidationError
    return (
      <div>
        <Dialog
          open={simcards.active !== null}
          onClose={() => simcardActions.resetNew()}
          classes={{
            paper: classes.dialogContent
          }}
        >
          <form onSubmit={e => this.submitChanges(e, simcards.active)}>
            <DialogTitle>{Y`Add Simcards`}</DialogTitle>
            <DialogContent>
              <TextField
                margin='normal'
                label={Y`First IMSI in series`}
                type='text'
                value={simcards.active.imsi || ''}
                onChange={this.inputChanged('imsi')}
                error={imsiValidationError}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                fullWidth
                required
              />
            </DialogContent>
            <DialogContent>
              <TextField
                margin='normal'
                select
                label={Y`Number of Simcards`}
                type='number'
                value={simcards.active.numberOfSimcards || ''}
                onChange={this.inputChanged('numberOfSimcards')}
                SelectProps={{
                  native: true,
                  MenuProps: {
                    className: classes.menu
                  }
                }}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                fullWidth
              >
                {numberOfSimcardsSelect.map(option => (
                  <option key={option.id} value={option.value}>
                    {Y`${option.value}`}
                  </option>
                ))}
              </TextField>
            </DialogContent>
            <DialogContent>
              <CountriesDropdown handleChange={this.inputChanged('country')} value={simcards.active.country || ''} />
            </DialogContent>
            <DialogContent>
              <TextField
                margin='normal'
                select
                label={Y`Product`}
                type='number'
                value={simcards.active.productId || ''}
                onChange={this.inputChanged('productId')}
                SelectProps={{
                  native: true,
                  MenuProps: {
                    className: classes.menu
                  }
                }}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                disabled={simcards.active.country === ''}
                fullWidth
              >
                <option key='' value=''>
                  {Y`Select product for these Simcards`}
                </option>
                {products.productsForCountry.map(product => (
                  <option key={product.id} value={product.id}>
                    {product.name}
                  </option>
                ))}
              </TextField>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => simcardActions.resetNew()}>{Y`Cancel`}</Button>
              <Button type='submit' disabled={imsiValidationError} variant='raised' color='primary' style={{ color: '#fff' }}>
                {Y`Save`}
              </Button>
            </DialogActions>
          </form>
        </Dialog>
      </div>
    )
  }
}

NewSimcardDialog = connect(mapStateToProps, mapDispatchToProps)(NewSimcardDialog)
export default withStyles(Styles)(NewSimcardDialog)



// WEBPACK FOOTER //
// ./src/pages/simcards/containers/new-simcard-dialog.js